import { Button, EButtonVariant } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

type Props = {
  showDelete: boolean;
  onSave: () => void;
  onDelete: () => void;
  disabled?: boolean;
};

export function ChequePrintTemplatesFooter({
  showDelete,
  onSave,
  onDelete,
  disabled,
}: Props): JSX.Element {
  return (
    <div className="flex flex-row justify-between items-center w-full">
      <div className="flex flex-row items-center">
        {showDelete && (
          <>
            <Button icon="delete" onClick={onDelete} disabled={disabled} />
            <HorizontalSpace size={11} />
          </>
        )}
      </div>
      <Button
        variant={EButtonVariant.SECONDARY}
        onClick={onSave}
        icon="galochka"
        disabled={disabled}
      >
        Сохранить
      </Button>
    </div>
  );
}
